module.exports = __webpack_public_path__ + "img/pos5_txt.f798f37b.png";